module.exports = __webpack_public_path__ + "img/structure03.e68cbb44.png";